import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { eventsBySectionsQuery } from "../../../../utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import endPointsSections from "../../../../store/models/endPointsSections";
import TimeLineCard from "./timeLineCard/TimeLineCard";
import Text from "../../../features/text/Text";
import emptyTimlineIcon from "../../../../../assests/myLearnPage/emptyTimlineIcon.png"
import classes from "./MatriculationTimeLine.module.css";

const NO_DATE = window.config.matriculationNoDate; // לדוג' "2025-07-30"

const isNoDate = (date) => {
    if (!date) return true;
    if (typeof date === "string") {
        return date.slice(0, 10) === NO_DATE;
    }
    return false;
};

const MatriculationTimeLine = () => {
    const myEventsQuery = useMemo(() => eventsBySectionsQuery(endPointsSections.myMatriculationEvents), []);
    const myEvents = useSelector((state) => selectEntitiesByFilters(state, myEventsQuery));
    const [matriculationWithoutBgt, setMatriculationWithoutBgt] = useState(null);
    const { domains } = useSelector((state) => state.uiData);
    const { texts } = useSelector(state => state.translate);

    // חלוקה לאירועים עם תאריך ובלי תאריך
    const eventsWithDate = useMemo(() => { return matriculationWithoutBgt?.filter(e => e.date && !isNoDate(e.date)) || []; }, [matriculationWithoutBgt]);
    const eventsWithoutDate = useMemo(() => { return matriculationWithoutBgt?.filter(e => !e.date || isNoDate(e.date)) || []; }, [matriculationWithoutBgt]);

    useEffect(() => {
        const regularMatriculation = myEvents.filter(e => e.providerName !== "bgt");
        setMatriculationWithoutBgt(regularMatriculation);
    }, [myEvents]);

    // יצירת אירועי דמה אם אין בכלל אירועים עם תאריך
    const fakeMatriculationData = Array.from({ length: 7 }, (_, i) => {
        const date = new Date();
        date.setMonth(date.getMonth() + i + 1, 1);
        return {
            date: date.toISOString(),
            title: `${texts.bagrut ?? ""} ${i + 1}`,
            fake: true
        };
    });

    const timelineData = eventsWithDate?.length > 0 ? eventsWithDate : fakeMatriculationData;

    return (
        <>
            {/* אירועים עם תאריך (או דמה) */}
            <div className={classes.ExternalMatriculation}>
                <p className={classes.MatriculationType}>{texts.external}</p>

                <div className={classes.TimeLineWrapper}>
                    <div className={classes.Line}></div>
                    <div className={classes.TimeLineCards}>
                        {timelineData.map((e, index) => (
                            <TimeLineCard
                                key={index}
                                date={e.date}
                                title={e.title}
                                description={e.description}
                                picture={e.picture}
                                fake={e.fake}
                                color={domains.find(domain => domain.name === e.domain)?.color}
                            />
                        ))}
                    </div>
                    {eventsWithDate?.length <= 0 && <div className={classes.EmptyTimlineMessage}>
                        <img className={classes.EmptyTimlineIcon} src={emptyTimlineIcon} alt={texts.noTimelineEvents} />
                        <p className={classes.EmptyTimlineText}>{texts.noTimelineEvents}</p>
                    </div>}
                </div>

            </div>

            {/* אירועים ללא תאריך */}
            {eventsWithoutDate.length > 0 && (
                <div className={classes.AlternativeMatriculations}>
                    <div className={classes.AlternativeMatriculationTitle}>
                        <p>{texts.alternativeMatriculation}</p>
                        <hr className={classes.Hr} />
                    </div>
                    <div className={classes.AlternativeContent}>
                        {eventsWithoutDate.map((event, index) => {
                            const currentDomain = domains.find(domain => domain.name === event.domain);
                            if (!currentDomain) return null;
                            return (
                                <div className={classes.AlternativeMatriculationItem} key={index}>
                                    <span className={classes.Circle} style={{ backgroundColor: currentDomain.color }}></span>
                                    <Text>{currentDomain.text?.all?.he || currentDomain.name}</Text>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default MatriculationTimeLine;